import React, { useContext, useEffect, useRef, useState } from "react";
import { simplifyUrl } from "../../../../../hooks/utils";
import { csrfToken } from "../../../../../utils/csrfTokenUtils";
import { hugRectToAspect } from "../../../../../utils/hugElementBox";
import { getNormalizedDimensions, gifProportion, constProportionRespectUserDrawnBox, roundTripSafeNormalize ,applyProportionalResize, getComparableTool, isPhoneLike, normalizePhone, normalizeUrlProtocol, isValidEmail, isValidHttpUrl, VALUE_FIELD_UI_DEFAULTS} from "../../../../../utils/helper";
import { isValidPhone } from "../../../../../utils/phoneValidation";
import { shouldShowEmbeddedContent } from "../../../../../utils/cookieConsentUtils";
import { EditorInfoContext } from "../../../../../utils/userInfoContext";
import { networkService } from "../../../../config/axios";
import { deleteElementById, patchElement, patchElementFromImageSnapshot, restoreElementById } from "../../../../../utils/elementHistoryActions";
import EmbedSection from "../elementModal/elementSections/embedSection/EmbedSection";
import HotspotSection from "../elementModal/elementSections/hotspotSection/HotspotSection";
import ImageSection from "../elementModal/elementSections/imageSection/ImageSection";
import TextEditorSection from "../elementModal/elementSections/textEditorSection/TextEditorSection";
import { scaleFontSizesInHtml } from "../../../../CommonComponents/HtmlText";
import { sanitizeHtml } from "../../../../../utils/sanitizeHtml";
import { loadGoogleFontsInHtml } from "../../../../../utils/googleFontLoader";
import VideoSection from "../elementModal/elementSections/videoSection/VideoSection";
import _ from "lodash";

export const actionKeys = ['page_link', 'url', 'mail', 'phone', 'link_title', 'kdf', 'link', 'kdf_title', 'light_box', 'lj_url', 'lj_mail', 'lj_phone', 'lj_page_link', 'action']
const useEditorHook = (closeModal, docData, totalPages, zoom, applyDesiredAction) => {
    const {
        setEditEnabled,
        geo,
        toolType,
        elements,
        editElement,
        imageElement,
        setEditElement,
        setElements,
        setToolType,
        setImageElement,
        setShowToast,
        pageDimensions,
        pushHistoryAction,
        setLiveTool,
    } = useContext(EditorInfoContext)

    // initial state for the element mpdal fields
    const [tool, setTool] = useState({
        // properties going to be hadled dynamically
        authenticity_token: csrfToken(),
        doc_id: docData?.doc_id,
        docs_file_id: docData?.id,
        other_files: [],
        other_files_element: [],
        value: editElement?.value ?? {
            no_scroll: true,
            timerField: "ViewPort",
            ...(toolType === 'HotspotToolbox' && { bg_color: VALUE_FIELD_UI_DEFAULTS.bg_color }),
        },
        page: editElement?.page ?? geo.page,
        geometry: {
            ...(toolType !== 'LightboxesToolbox' && {
                left: editElement?.geometry?.left ?? geo?.width == 0 ? geo?.left - 50 : geo?.left,
                top: editElement?.geometry?.top ?? geo?.height == 0 ? geo?.top - 50 : geo?.top,
                width: editElement?.geometry?.width ?? (geo?.width < 50 && geo?.height < 50) ? 50 : geo?.width,
                height: editElement?.geometry?.height ?? (geo?.width < 50 && geo?.height < 50) ? 50 : geo?.height,
            }),
            keep_proportions: editElement?.geometry?.keep_proportions ?? (toolType == 'TextToolbox' || toolType == 'HotspotToolbox' || toolType == 'EmbedToolbox') ? false : true,
            keep_within_page: editElement?.geometry?.keep_within_page ?? true,
            hide_beyond_page_edges: editElement?.geometry?.hide_beyond_page_edges ?? false
        },
        sec_to_delay: editElement?.sec_to_delay ?? 0,
        disappear_after: 0,
        jump_to_page: '',
        action: 'none',
        disappear_after: editElement?.disappear_after ?? 0,
        scrolling : false,
        ...(editElement?.gif_type && { gif_type: editElement?.gif_type }),
    })

    // error state 
    const [errorState, setErrorState] = useState({
        videoErr: '',
        embedErr: '',
        textErr: '',
        imgErr: '',
        dimensionError: '',
        tagErr: '',
        pageErr: '',
        ljErr: '',
        hrefErr: '',
        kdfErr: ''
    })
    const [initialTool, setInitialTool] = useState(tool);
    const confirmedGeometry = useRef(tool.geometry);
    const lockRatioRef = useRef(null);
    const [initialEditElement, setInitialEditElement] = useState(editElement);
    const [isChanged, setIsChanged] = useState(false);
    //new for error boundry
    const [showExtendModal, setShowExtendModal] = useState(false);
    const [embedConsent, setEmbedConsent] = useState(shouldShowEmbeddedContent);
    useEffect(() => {
        const sync = () => setEmbedConsent(shouldShowEmbeddedContent());
        window.addEventListener('cookieConsentChanged', sync);
        return () => window.removeEventListener('cookieConsentChanged', sync);
    }, []);
    const [scrollActive, setScrollActive] = useState(() => {
        // Load initial state from sessionStorage
        const saved = sessionStorage.getItem("scrolling");
        return saved === "true"; // default: false
      });

        const handleSubmitBtnState = () => {
                const generalChanges = !_.isEqual(getComparableTool(tool), getComparableTool(initialTool)) || !_.isEqual(editElement, initialEditElement);
                const tagsChanged = !_.isEqual(tool.tags, initialTool.tags);
                const flipChanged = !_.isEqual(tool.flip, initialTool.flip);
                const hasChanged = generalChanges || tagsChanged || flipChanged;            
                setIsChanged(hasChanged);
            };   

    useEffect(() => {
        if (tool?.value?.link) setErrorState((prevErr) => (prevErr.kdfErr ? { ...prevErr, kdfErr: '' } : prevErr));
    }, [tool?.value?.link]);

    useEffect(() => {
        sessionStorage.setItem("scrolling", scrollActive);
        if (!Object.values(editElement).length > 0) {
            handleSubmitBtnState();
        }
    }, [tool, editElement]);

    //handle text editor change 
   const handleChange = (e) => {
  const { name, type, value, checked } = e.target;
  const actionNames = [
    "jump_to_page",
    "href",
    "kdf",
    "light_box",
    "link_title",
    "kdf_title",
    "action",
    "desiredaction",
    "thisElement",
    "frequency_animation",
    "timerField",
    "link_and_jump_page",
    "link_and_jump_url",
  ];

  if (name === "scrolling") {
  setScrollActive(checked);
  setTool((prev) => ({
    ...prev,
    value:{
      ...prev.value,
      reactivate_scroll : checked,
      reactive : checked ? "reactive" :''
    }
    
  }));
  handleSubmitBtnState();
  return;
}

  if (name === "action") {
    document.querySelectorAll("input[name='action']").forEach((radio) => {
      radio.checked = false;
    });
    e.target.checked = true;
  }

  switch (true) {
    case name === "bg_color": {
      setTool((prev) => ({
        ...prev,
        value: {
          ...prev.value,
          [name]: value,
        },
      }));
      break;
    }

    case name === "transparency": {
      setTool((prev) => ({
        ...prev,
        [name]: value,
      }));
      break;
    }


case name.startsWith("geometry."): {
  localStorage.setItem("is_changed_model", "true");

  const geometryKey = name.split(".")[1];
  const parsedValue =
    type === "checkbox" ? checked : value !== "" ? Number(value) : value;

  if (["width", "height"].includes(geometryKey) && parsedValue !== "" && parsedValue <= 0) {
    setErrorState((prevErr) => ({
      ...prevErr,
      dimensionError: "Width and height must be greater than 0",
    }));
    break;
  }
  setErrorState((prevErr) => ({ ...prevErr, dimensionError: "" }));

  setTool((prev) => {
    const prevGeo = prev.geometry || {};
    
    // For images, use file_details dimensions; for videos/embeds, use embed_dimensions
    let originalImageWidth, originalImageHeight;
    
    if (prev.file_details?.dimensions?.width && prev.file_details?.dimensions?.height) {
      // Image element
      originalImageWidth = prev.file_details.dimensions.width;
      originalImageHeight = prev.file_details.dimensions.height;
    } else if (prev.embed_dimensions?.width && prev.embed_dimensions?.height) {
      // Video/embed element with stored embed dimensions
      originalImageWidth = prev.embed_dimensions.width;
      originalImageHeight = prev.embed_dimensions.height;
    } else if (prev.value?.embed_dimensions?.width && prev.value?.embed_dimensions?.height) {
      // Video/embed element with dimensions stored in value
      originalImageWidth = prev.value.embed_dimensions.width;
      originalImageHeight = prev.value.embed_dimensions.height;
    } else if (prev.original_width && prev.original_height) {
      originalImageWidth = prev.original_width;
      originalImageHeight = prev.original_height;
    } else {
      const currentRatio = (prevGeo.width || 1) / (prevGeo.height || 1);
      if (!lockRatioRef.current || Math.abs(currentRatio - lockRatioRef.current) / lockRatioRef.current > 0.02) {
        lockRatioRef.current = currentRatio;
      }
      originalImageWidth = lockRatioRef.current;
      originalImageHeight = 1;
    }
    
    let newGeo = {
      ...prevGeo,
      [geometryKey]: parsedValue,
    };

    // Make keep_within_page and hide_beyond_page_edges mutually exclusive
    let movedIntoPage = [];
    if (geometryKey === "keep_within_page" && parsedValue === true) {
      newGeo.hide_beyond_page_edges = false;
      const clampAxis = (key, sizeKey, pageSize) => {
        const pos = Number(newGeo[key]);
        if (!Number.isFinite(pos)) return;
        const size = Number(newGeo[sizeKey]) || 0;
        const max = Number.isFinite(pageSize) ? Math.max(0, pageSize - size) : Infinity;
        const clamped = Math.min(Math.max(pos, 0), max);
        if (clamped !== pos) {
          newGeo[key] = Math.round(clamped);
          movedIntoPage.push(key);
        }
      };
      clampAxis("left", "width", pageDimensions?.width);
      clampAxis("top", "height", pageDimensions?.height);
    }
    if (geometryKey === "hide_beyond_page_edges" && parsedValue === true) {
      newGeo.keep_within_page = false;
    }

    if (geometryKey === "keep_proportions") {
      newGeo.keep_proportions = parsedValue;
      lockRatioRef.current = null;
    }

    // Maintain original aspect ratio (for both images and videos/embeds)
    if (
      newGeo.keep_proportions &&
      (geometryKey === "width" || geometryKey === "height")
    ) {
      const aspectRatio = originalImageWidth / originalImageHeight;

      if (geometryKey === "width") {
        const width = parsedValue;
        const height = Math.round(width / aspectRatio);
        newGeo.width = width;
        newGeo.height = height;
      } else if (geometryKey === "height") {
        const height = parsedValue;
        const width = Math.round(height * aspectRatio);
        newGeo.height = height;
        newGeo.width = width;
      }
    }

    // Check for boundary overflow
    const pageWidth = pageDimensions?.width;
    const pageHeight = pageDimensions?.height;
    const newLeft = newGeo.left ?? prevGeo.left ?? 0;
    const newTop = newGeo.top ?? prevGeo.top ?? 0;

    let isExtendingBeyond = false;

    if (["width", "height", "left", "top"].includes(geometryKey)) {
      const finalWidth = newGeo.width ?? prevGeo.width ?? 0;
      const finalHeight = newGeo.height ?? prevGeo.height ?? 0;

      if (pageWidth && newLeft + finalWidth > pageWidth) isExtendingBeyond = true;
      if (pageHeight && newTop + finalHeight > pageHeight) isExtendingBeyond = true;

      if (newLeft < 0) isExtendingBeyond = true;
      if (newTop < 0) isExtendingBeyond = true;
    }

    const shouldKeepWithinPage = newGeo.keep_within_page !== false;
    const needsConfirm = isExtendingBeyond && shouldKeepWithinPage;
    setShowExtendModal(needsConfirm);
    if (!needsConfirm && [newLeft, newTop, newGeo.width, newGeo.height].every(Number.isFinite)) {
      confirmedGeometry.current = { left: newLeft, top: newTop, width: newGeo.width, height: newGeo.height };
    }

    // Clear base geometry for user-modified dimensions to prevent rounding drift on save
    let updatedBaseGeo = prev._baseGeometry ? { ...prev._baseGeometry } : undefined;
    if (updatedBaseGeo && ["width", "height", "top", "left"].includes(geometryKey)) {
      updatedBaseGeo[geometryKey] = undefined;
      if (newGeo.keep_proportions && (geometryKey === "width" || geometryKey === "height")) {
        updatedBaseGeo.width = undefined;
        updatedBaseGeo.height = undefined;
      }
    }
    if (updatedBaseGeo) movedIntoPage.forEach((key) => { updatedBaseGeo[key] = undefined; });
    if (movedIntoPage.length && [newGeo.left, newGeo.top, newGeo.width, newGeo.height].every(Number.isFinite)) {
      confirmedGeometry.current = { left: newGeo.left, top: newGeo.top, width: newGeo.width, height: newGeo.height };
    }

    return {
      ...prev,
      geometry: newGeo,
      ...(updatedBaseGeo !== undefined && { _baseGeometry: updatedBaseGeo }),
    };
  });

  break;
}


    case ["animation", "frequency", "disappear", "timerField", "disappear_after"].includes(
      name
    ): {
      setTool((prev) => ({
        ...prev,
        ...(name === "disappear_after" && { disappear_after: Number(value) }),
        value: {
          ...prev.value,
          ...(name === "disappear_after" && value == 0
            ? { disappear: "" }
            : { [name]: value }),
        },
      }));
      break;
    }

    case actionNames.includes(name) || value === "desiredaction" || value === "page": {
      setErrorState({ ...errorState, pageErr: "" });

      setTool((prev) => {
        let updatedValue = { ...prev?.value } || {};
        let actionValue = name;

        let dropdown_data = prev.dropdown_data;

        if (name === "action" && value === "none") {
          updatedValue = {};
          actionValue = "none";

          dropdown_data = null;
        } else if (name === "action" && ["page", "href", "on", "kdf"].includes(value)) {
          const keepKeys = {
            page: ["page_link"],
            href: ["url", "mail", "phone"],
            on: ["light_box"],
            kdf: ["kdf", "kdf_title", "link_title"],
          }[value];
          updatedValue = keepKeys.reduce(
            (acc, key) => (prev?.value?.[key] ? { ...acc, [key]: prev.value[key] } : acc),
            {}
          );
          actionValue = value;
        } else if (
          ["desiredaction", "thisElement", "frequency_animation", "timerField"].includes(
            name
          ) ||
          value === "desiredaction"
        ) {
          actionValue = "desiredaction";
          dropdown_data =
            value === "desiredaction"
              ? {
                  frequency: "OnEveryClick",
                  thisElement: "thisElement",
                  desiredaction: "hide",
                }
              : {
                  frequency: "OnEveryClick",
                  thisElement: "thisElement",
                  desiredaction: "hide",
                  ...prev.dropdown_data,
                  ...(name === "frequency_animation"
                    ? { frequency: value }
                    : { [name]: value }),
                };
          updatedValue = {};
        } else if (["jump_to_page", "page"].includes(name)) {
          const clampedValue = value !== "" && Number(value) > Number(totalPages) ? String(totalPages) : value;
          if (Number(clampedValue) === tool?.page) {
            setErrorState((prevErr) => ({
              ...prevErr,
              pageErr: "Please add a page number other than current page",
            }));
          } else {
            setErrorState((prevErr) => ({
              ...prevErr,
              pageErr: "",
            }));
          }
          updatedValue = { page_link: clampedValue };
          actionValue = "page";
        } else if (value === "on" || name === "light_box") {
          updatedValue = { light_box: value };
          actionValue = "on";
        } else if (name === "href") {
          setErrorState((prevErr) => ({ ...prevErr, hrefErr: "" }));
          updatedValue = {};
          if (!value.trim() || value === "https://" || value === "@") {
            updatedValue = {};
          } else if (value.includes("@")) {
            // Any value with @ is treated as email (including partial input like "user@domain").
            // Full regex validation only when complete — don't prepend https:// mid-typing.
            if (/\S+@\S+\.\S+/.test(value)) {
              updatedValue.mail = value; // complete email
            } else {
              updatedValue.mail = value; // partial email — store as-is, no https://
            }
          } else if (e.target.linkType === "phone" || isPhoneLike(value)) {
            updatedValue.phone = normalizePhone(value);
          } else {
            updatedValue.url = normalizeUrlProtocol(value);
          }
          actionValue = "href";
        } else if (value === "link_and_jump" || name === "link_and_jump_page" || name === "link_and_jump_url") {
          actionValue = "link_and_jump";
          setErrorState((prevErr) => ({ ...prevErr, ljErr: "" }));
          if (value === "link_and_jump") {
            // Radio button selected - preserve existing lj_ values
            updatedValue = {};
            if (prev?.value?.lj_url) updatedValue.lj_url = prev.value.lj_url;
            if (prev?.value?.lj_mail) updatedValue.lj_mail = prev.value.lj_mail;
            if (prev?.value?.lj_phone) updatedValue.lj_phone = prev.value.lj_phone;
            if (prev?.value?.lj_page_link) updatedValue.lj_page_link = prev.value.lj_page_link;
          } else if (name === "link_and_jump_url") {
            // URL/email/phone input changed - preserve lj_page_link
            updatedValue = {};
            if (prev?.value?.lj_page_link) updatedValue.lj_page_link = prev.value.lj_page_link;
            if (!value.trim() || value === "https://" || value === "@") {
              // empty
            } else if (value.includes("@")) {
              // Any value with @ is treated as email — don't prepend https:// mid-typing
              updatedValue.lj_mail = value;
            } else if (e.target.linkType === "phone" || isPhoneLike(value)) {
              updatedValue.lj_phone = normalizePhone(value);
            } else {
              updatedValue.lj_url = normalizeUrlProtocol(value);
            }
          } else if (name === "link_and_jump_page") {
            // Page input changed - preserve lj_ link values
            const clampedValue = value !== "" && Number(value) > Number(totalPages) ? String(totalPages) : value;
            if (Number(clampedValue) === tool?.page) {
              setErrorState((prevErr) => ({
                ...prevErr,
                pageErr: "Please add a page number other than current page",
              }));
            } else {
              setErrorState((prevErr) => ({
                ...prevErr,
                pageErr: "",
              }));
            }
            updatedValue = {};
            if (prev?.value?.lj_url) updatedValue.lj_url = prev.value.lj_url;
            if (prev?.value?.lj_mail) updatedValue.lj_mail = prev.value.lj_mail;
            if (prev?.value?.lj_phone) updatedValue.lj_phone = prev.value.lj_phone;
            updatedValue.lj_page_link = clampedValue;
          }
        } else if (name === "kdf_title") {
          updatedValue = { kdf_title: value };
          actionValue = "kdf";
          setErrorState((prevErr) => ({ ...prevErr, kdfErr: "" }));
        } else if (name === "link_title") {
          updatedValue = {
            kdf: prev?.value?.kdf,
            kdf_title: prev?.value?.kdf_title,
            link_title: value,
          };
          actionValue = "kdf";
          setErrorState((prevErr) => ({ ...prevErr, kdfErr: "" }));
        } else {
          updatedValue[name] = value;
        }

        // Clear all action keys to prevent conflicts when switching actions
        const prevValueWithoutActions = Object.keys(prev?.value || {})
          .filter(key => !actionKeys.includes(key))
          .reduce((obj, key) => {
            obj[key] = prev.value[key];
            return obj;
          }, {});

        if (actionValue !== "desiredaction") {
          dropdown_data = {};
        }

        return {
          ...prev,
          dropdown_data,
          action: actionValue,
          value: {
            ...prevValueWithoutActions,
            ...updatedValue,
          },
        };
      });

      break;
    }

    case name === "flip": {
      setTool((prev) => ({
        ...prev,
        flip: type === "checkbox" ? checked : value,
      }));
      break;
    }

    case name === "tags": {
      setTool((prev) => ({
        ...prev,
        tags: value,
      }));
      break;
    }

    default: {
      // Validate SHOW ON PAGE against JUMP TO PAGE
      if (name === "page") {
        const pageValue = value === "" ? "" : Number(value) || 1;
        const jumpToPageValue = tool?.jump_to_page !== undefined ? tool?.jump_to_page : tool?.value?.page_link;
        
        if (jumpToPageValue !== undefined && jumpToPageValue !== null && jumpToPageValue !== "" && Number(pageValue) === Number(jumpToPageValue)) {
          setErrorState((prevErr) => ({
            ...prevErr,
            pageErr: "Please add a page number other than current page",
          }));
        } else {
          setErrorState((prevErr) => ({
            ...prevErr,
            pageErr: "",
          }));
        }
      }
      
      setTool((prev) => ({
        ...prev,
        [name]:
          type === "checkbox"
            ? checked
            : type === "number"
            ? name === "page"
              ? value === ""
                ? ""
                : Number(value) || 1
              : Number(value)
            : value,
      }));
      break;
    }
  }

  handleSubmitBtnState();
};

    const handleTextChange = (data) => {
        setTool((prevValues) => ({
            ...prevValues,
            element_type: 7,
            value: {
                ...prevValues.value,
                html_text: data,
                timerField: prevValues.value?.timerField ?? "ViewPort"
            },
        }));
        setErrorState({
            ...errorState,
            textErr: ''
        })
        handleSubmitBtnState();
    }

    const handleHtmlChange = (data) => {
        setTool((prevValues) => ({
            ...prevValues,
            element_type: 12,
            value: {
                ...prevValues.value,
                html_text: data,
                timerField: prevValues.value?.timerField ?? "ViewPort"
            },
        }));
        setErrorState({
            ...errorState,
            textErr: ''
        })
        handleSubmitBtnState();
    }

    // Unsplash photographer credit lives on value; drop it whenever the image changes.
    const withoutUnsplashCredit = ({ unsplash_id, unsplash_user_name, unsplash_user_link, ...rest } = {}) => rest;

    // handle the select the gifs and unsplash photos
    const handleSelectGifs = (type, url, dimensions, extraValue = {}) => {
        setErrorState({ ...errorState, imgErr: '' })
        let _gifProportion = gifProportion(tool?.geometry?.width, tool?.geometry?.height, dimensions?.width, dimensions?.height);
        const { file, file_url, file_details, ...toolWithoutFile } = tool;
        setTool({
            ...toolWithoutFile,
            _baseGeometry: tool._baseGeometry ? {
                ...tool._baseGeometry,
                width: undefined,
                height: undefined,
            } : undefined,
            geometry: {
                ...tool?.geometry,
                width: _gifProportion[0],
                height: _gifProportion[1],
            },
            gif_type: type,
            image_text: "",
            image_type: null,
            element_type: '4',
            rotate: 0,
            flip: 1,
            is_tenor: type == 'tenor',
            recurrence: "OncePerVisit",
            value: { ...withoutUnsplashCredit(tool?.value), ...extraValue, timerField: tool?.value?.timerField ?? "ViewPort", gif_link: url , reactivate_scroll: tool?.value.reactivate_scroll }
        })
        handleSubmitBtnState();
    }

    const isImageFile = (file) => {
        if (!file.type.startsWith('image/')) {
            return false;
        }
        return true;
    };

    const handleImageUpload = (event, action) => {
      setEditEnabled(false);

      if (action === "cancel") {
        const { gif_link, ...restValue } = withoutUnsplashCredit(tool?.value);
        setTool({ ...tool, file: null, gif_type: null, is_tenor: false, original_width: undefined, original_height: undefined, value: restValue });
        handleSubmitBtnState();
        return;
      }

      if (action === "upload") {
        const file = event.target.files?.[0];
        setErrorState((prev) => ({ ...prev, imgErr: "" }));

        if (!file || !isImageFile(file)) {
          setErrorState((prev) => ({
            ...prev,
            imgErr: "Please upload a valid image file.",
          }));
          event.target.value = null;
          return;
        }

        const img = new Image();
        img.src = URL.createObjectURL(file);

        img.onload = () => {
          const imgWidth = img.width;
          const imgHeight = img.height;

          // Use editElement geometry as source of truth for saved position when replacing image
          // This ensures the exact position (left, top) is preserved after dragging and saving
          const savedGeo = editElement?.geometry || {};
          const existingGeo = tool?.geometry || {};
          
          // Keep existing screen-space coords for display so modal inputs don't jump.
          // savedGeo has base coords (from DB); existingGeo has screen coords (current zoom).
          // We prefer screen coords for display; _baseGeometry handles the correct base
          // values at save time via handleSave and uploadElement.
          const preservedLeft = existingGeo.left ?? savedGeo.left ?? 0;
          const preservedTop = existingGeo.top ?? savedGeo.top ?? 0;
          const hugged = hugRectToAspect(
            {
              left: preservedLeft,
              top: preservedTop,
              width: existingGeo.width ?? savedGeo.width ?? imgWidth,
              height: existingGeo.height ?? savedGeo.height ?? imgHeight,
            },
            imgWidth / imgHeight
          );
          const dimensionsChanged =
            hugged.width !== existingGeo.width || hugged.height !== existingGeo.height ||
            hugged.left !== existingGeo.left || hugged.top !== existingGeo.top;

          const {
            file_url,
            file_details,
            is_tenor,
            gif_type,
            ...toolWithoutFileUrl
          } = tool;

          const { gif_link, ...updatedValue } = withoutUnsplashCredit(toolWithoutFileUrl?.value);

          setTool({
            ...toolWithoutFileUrl,
            original_width: imgWidth,
            original_height: imgHeight,
            file_cache: "",
            ...(toolWithoutFileUrl._baseGeometry && dimensionsChanged && {
              _baseGeometry: {
                ...toolWithoutFileUrl._baseGeometry,
                width: undefined,
                height: undefined,
                left: undefined,
                top: undefined,
              },
            }),
            geometry: {
              ...savedGeo,
              ...existingGeo,
              ...hugged,
              keep_proportions: savedGeo.keep_proportions ?? existingGeo.keep_proportions ?? true,
            },
            transparency: toolWithoutFileUrl?.transparency ?? 1,
            element_type: "4",
            gif_type: "image",
            file: file,
            value: {
              ...updatedValue,
              timerField: updatedValue?.timerField ?? "ViewPort",
              reactivate_scroll: updatedValue?.reactivate_scroll ? true:false,
            },
          });

          handleSubmitBtnState();
        };
      }
    };


    const handleElementUpload = (event, type) => {
        if (event.target?.name !== 'no_scroll') {
            const embedCode = event.target.value;
            let source = "";
            let videoLink = "";
            let embedWidth = null;
            let embedHeight = null;
            
            const hasIframe = /<iframe/i.test(embedCode);
            const isPureScript = /<script/i.test(embedCode) && !hasIframe;

            if (hasIframe) {
                const normalizedCode = embedCode.replace(/&quot;/g, '"');
                const srcMatch = normalizedCode.match(/src="([^"]*)"/i);
                videoLink = srcMatch ? srcMatch[1] : "";
                videoLink = videoLink.replace(/&amp;/g, '&').replace(/&amp;/g, '&');

                const widthMatch = embedCode.match(/width=["']?(\d+)["']?/i);
                const heightMatch = embedCode.match(/height=["']?(\d+)["']?/i);

                if (widthMatch && widthMatch[1]) {
                    embedWidth = parseInt(widthMatch[1], 10);
                }
                if (heightMatch && heightMatch[1]) {
                    embedHeight = parseInt(heightMatch[1], 10);
                }

                if (!embedWidth || !embedHeight) {
                    const paddingMatch = embedCode.match(/padding[^:]*:\s*(\d+(?:\.\d+)?)%/i);
                    if (paddingMatch) {
                        const aspectRatio = parseFloat(paddingMatch[1]) / 100;
                        embedWidth = 640;
                        embedHeight = Math.round(640 * aspectRatio);
                    }
                }
            } else if (isPureScript) {
                videoLink = embedCode.replace(/src="\/\//g, 'src="https://').replace(/href="\/\//g, 'href="https://');
            } else {
                const dataUrlMatch = embedCode.match(/data-url="([^"]*)"/i);
                const hrefMatch = embedCode.match(/href="([^"]*)"/i);
                const srcMatch = embedCode.match(/src="([^"]*)"/i);
                if (dataUrlMatch) {
                    videoLink = dataUrlMatch[1];
                } else if (hrefMatch) {
                    videoLink = hrefMatch[1];
                } else if (srcMatch) {
                    videoLink = srcMatch[1];
                } else {
                    videoLink = embedCode; // If it's already a URL
                }
            }

            if (!isPureScript) {
                videoLink = (videoLink || "").trim();
                const previousUrl = tool?.value?.video_link || "";
                const isDeleting = videoLink.length < previousUrl.length;
                const alreadyHasProtocol = /^https?:\/\//i.test(videoLink);

                if (videoLink && videoLink.toLowerCase().startsWith("http://")) {
                    videoLink = videoLink.replace(/^http:\/\//i, "https://");
                } else if (videoLink && videoLink.startsWith("//")) {
                    videoLink = "https:" + videoLink;
                } else if (videoLink && !alreadyHasProtocol && !isDeleting) {
                    videoLink = "https://" + videoLink;
                }
            }

            // Special handling for Wistia videos
            if (videoLink.includes('fast.wistia.com/embed/medias/')) {
                const match = videoLink.match(/embed\/medias\/([a-zA-Z0-9]+)\.jsonp/);
                if (match && match[1]) {
                    const wistiaId = match[1];
                    videoLink = `https://fast.wistia.net/embed/iframe/${wistiaId}`;
                    source = 'wistia';
                }
            }
    
            // Special handling for Loom videos
            if (videoLink.includes('loom.com/share/')) {
                videoLink = videoLink.replace('loom.com/share/', 'loom.com/embed/');
            } else if (videoLink.includes('loom.com/embed/')) {
                source = 'loom'; // Mark source as Loom
            }
    
            // If type is 'embed', apply necessary transformations
            if (type === 'embed') {
                if (videoLink.includes('canva')) {
                    const url = simplifyUrl(embedCode);
                    videoLink = url + "?embed";
                }
            }
    
            // Handle Facebook embeds separately
            if (videoLink.includes('facebook.com')) {
                videoLink = "https://www.facebook.com/plugins/post.php?href=" + videoLink;
            }
    
            // Pasted text is still saved to video_link below (field stays editable); handleValidations blocks Save via errorState while isInvalidEmbed is true.
            const INVALID_EMBED_MESSAGE = "Hey, this doesn't look like an embed code. Please paste the embed code instead.";
            let isInvalidEmbed = false;

            // Detect Source Type
            if (/youtube\.com|youtu\.be/i.test(embedCode)) {
                source = 'youtube';
            } else if (embedCode.includes('vimeo')) {
                source = 'vimeo';
            } else if (embedCode.includes('soundcloud')) {
                source = 'soundcloud';
            } else if (embedCode.includes('wistia')) {
                source = 'wistia';
            }

            // Reject a bare watch/share page link (e.g. youtu.be with si=) — only real embed-format URLs pass, per ALWAYS_EMBEDDABLE_PATTERNS below.
            if (videoLink && ['youtube', 'vimeo', 'wistia'].includes(source)) {
                const isEmbedFormat = ALWAYS_EMBEDDABLE_PATTERNS.some((pattern) => pattern.test(videoLink));
                if (!isEmbedFormat) {
                    isInvalidEmbed = true;
                    source = ''; // not a confirmed/usable source until corrected
                    setShowToast({
                        showToast: true,
                        toastType: 'danger',
                        toastMessage: INVALID_EMBED_MESSAGE,
                    });
                }
            }
    
            // Get current geometry
            const existingGeo = tool?.geometry || {};
            let updatedGeometry = { ...existingGeo };
            
            if (embedWidth && embedHeight) {
                updatedGeometry = hugRectToAspect(
                    { left: existingGeo.left, top: existingGeo.top, width: existingGeo.width || embedWidth, height: existingGeo.height || embedHeight },
                    embedWidth / embedHeight
                );
                updatedGeometry = { ...existingGeo, ...updatedGeometry };
            }

            // Update State
            setTool((prevTool) => {
                const { source: _staleSource, ...valueWithoutSource } = prevTool.value || {};
                return {
                    ...prevTool,
                    element_type: type === 'embed' ? '6' : type === 'video' ? '5' : '8',
                    tags: prevTool?.tags || [],
                    ...(embedWidth && embedHeight && prevTool._baseGeometry && {
                        _baseGeometry: {
                            ...prevTool._baseGeometry,
                            width: undefined,
                            height: undefined,
                            left: undefined,
                            top: undefined,
                        }
                    }),
                    geometry: updatedGeometry,
                    ...(embedWidth && embedHeight && {
                        embed_dimensions: {
                            width: embedWidth,
                            height: embedHeight
                        }
                    }),
                    value: {
                        ...valueWithoutSource,
                        timerField: prevTool.value?.timerField ?? "ViewPort",
                        video_link: videoLink,
                        ...(source && { source }),
                        ...(type === 'embed' && { no_scroll: prevTool.value?.no_scroll ?? true, no_js: true }),
                        reactivate_scroll: prevTool.value?.reactivate_scroll,
                        ...(embedWidth && embedHeight && {
                            embed_dimensions: {
                                width: embedWidth,
                                height: embedHeight
                            }
                        })
                    }
                };
            });
    
            setErrorState({
                ...errorState,
                videoErr: isInvalidEmbed && type === 'video' ? INVALID_EMBED_MESSAGE : '',
                embedErr: isInvalidEmbed && type === 'embed' ? INVALID_EMBED_MESSAGE : '',
            });
        } else {
            setTool({
                ...tool,
                value: {
                    ...tool?.value,
                    ...(type === 'embed' && { no_scroll: event?.target?.checked, no_js: true })
                }
            });
        }
        handleSubmitBtnState();
    };
    
    const handleSubmitElement = (e, elemId, elementName) => {
        e?.preventDefault();
        e && uploadElement(elemId, elementName);
    };

    const handleSave = (payload) => {
        const url = `/docs/elements${payload?.id ? '/' + payload?.id : ''}.json`;
        // Normalize geometry to base coords before sending (same logic as uploadElement),
        // then strip the internal _baseGeometry tracking field from the request.
        const baseGeo = payload._baseGeometry || {};
        const zoomValue = zoom?.value ?? 1;
        const { _baseGeometry, ...cleanPayload } = payload;
        const sendPayload = cleanPayload.geometry ? {
            ...cleanPayload,
            geometry: {
                ...cleanPayload.geometry,
                width:  baseGeo.width  != null ? baseGeo.width  : roundTripSafeNormalize(cleanPayload.geometry.width,  zoomValue, 1),
                height: baseGeo.height != null ? baseGeo.height : roundTripSafeNormalize(cleanPayload.geometry.height, zoomValue, 1),
                top:    baseGeo.top    != null ? baseGeo.top    : roundTripSafeNormalize(cleanPayload.geometry.top,    zoomValue, 1),
                left:   baseGeo.left   != null ? baseGeo.left   : roundTripSafeNormalize(cleanPayload.geometry.left,   zoomValue, 1),
            },
        } : cleanPayload;
        networkService(url, "PATCH", sendPayload)
            .then((response) => {
                if ((response.status == 200)) {
                    setElements(prev => ({ ...prev, [response?.data?.id]: response?.data }));
                }
            })
            .catch((error) => {
                console.error(error)
            });
    };


    const EMBED_BLOCKED_MESSAGE = 'This website restricts iframe embedding for security reasons.';

    // URLs that are always embeddable by design — skip the server-side check to avoid
    // false positives caused by API key domain restrictions or server-side redirects.
    const ALWAYS_EMBEDDABLE_PATTERNS = [
      // Google (embed and regular map URLs)
      /(?:www\.)?google\.com\/maps/i,
      /maps\.google\.com\/maps/i,
      /calendar\.google\.com\/calendar\/embed/i,
      /docs\.google\.com\/(?:document|spreadsheets|presentation|forms)\//i,
      // Video
      /(?:[\w-]+\.)?youtube(?:-nocookie)?\.com\/embed\//i,
      /player\.vimeo\.com\/video\//i,
      /(?:fast\.)?wistia\.(?:com|net)\/embed\//i,
      /(?:www\.)?loom\.com\/embed\//i,
      /(?:www\.)?dailymotion\.com\/embed\//i,
      /(?:[\w-]+\.)?vidyard\.com\//i,
      // Audio
      /(?:w\.)?soundcloud\.com\/player/i,
      /open\.spotify\.com\/embed\//i,
      // Scheduling / forms
      /calendly\.com\//i,
      /(?:[\w-]+\.)?typeform\.com\/to\//i,
      /(?:[\w-]+\.)?hubspot(?:forms)?\.com\//i,
      // Presentations / docs
      /(?:www\.)?slideshare\.net\/slideshow\/embed_code\//i,
      /onedrive\.live\.com\/embed/i,
      /(?:www\.)?scribd\.com\/embeds\//i,
    ];

    const uploadElement = async (elementId, elementType, skipPageElements = false) => {
  // For embed elements, block save if the URL restricts iframe embedding (same message as SafeIFrame fallback)
  const isEmbedElement = toolType === 'EmbedToolbox' || editElement?.element_type === 6;
  const isScriptEmbed = /<script/i.test(tool?.value?.video_link);
  const isSamePlatform = (() => {
    try {
      const targetHost = new URL(tool?.value?.video_link).hostname;
      const currentHost = window.location.hostname;
      const reg = (h) => h.split(".").slice(-2).join(".");
      return reg(targetHost) === reg(currentHost);
    } catch (_) { return false; }
  })();
  const isAlwaysEmbeddable = isSamePlatform || (tool?.value?.video_link &&
    ALWAYS_EMBEDDABLE_PATTERNS.some(p => p.test(tool.value.video_link)));

  if (isEmbedElement && tool?.value?.video_link && !isScriptEmbed && !isAlwaysEmbeddable) {
    try {
      const url = `/api/v1/embed_check?url=${encodeURIComponent(tool.value.video_link)}`;
      const resp = await fetch(url, { signal: AbortSignal.timeout(8000) });
      if (resp.ok) {
        const data = await resp.json();
        if (data.embeddable === false) {
          setErrorState((prev) => ({ ...prev, embedErr: EMBED_BLOCKED_MESSAGE }));
          return;
        }
      }
    } catch (err) {
      // Network/timeout: allow save; viewer will still show wrapper fallback if embed fails.
      console.error(err);
    }
  }

  if (handleValidations(tool) || elementType === 'image') {
    // Use preserved base geometry for unchanged dimensions to prevent rounding drift
    const baseGeo = tool._baseGeometry || {};
    const zoomValue = zoom?.value ?? 1;
    const updatedGeometry = {
      ...tool.geometry,
      width:  baseGeo.width  != null ? baseGeo.width  : roundTripSafeNormalize(tool.geometry.width,  zoomValue, 1),
      height: baseGeo.height != null ? baseGeo.height : roundTripSafeNormalize(tool.geometry.height, zoomValue, 1),
      top:    baseGeo.top    != null ? baseGeo.top    : roundTripSafeNormalize(tool.geometry.top,    zoomValue, 1),
      left:   baseGeo.left   != null ? baseGeo.left   : roundTripSafeNormalize(tool.geometry.left,   zoomValue, 1),
      geo:{
        ...tool.geometry.geo,
        width:  baseGeo.width  != null ? baseGeo.width  : roundTripSafeNormalize(tool.geometry.width,  zoomValue, 1),
        height: baseGeo.height != null ? baseGeo.height : roundTripSafeNormalize(tool.geometry.height, zoomValue, 1),
        top:    baseGeo.top    != null ? baseGeo.top    : roundTripSafeNormalize(tool.geometry.top,    zoomValue, 1),
        left:   baseGeo.left   != null ? baseGeo.left   : roundTripSafeNormalize(tool.geometry.left,   zoomValue, 1),
      }
    };
    // Exclude internal _baseGeometry tracking from server payload
    const { _baseGeometry: _omitBaseGeo, ...toolPayload } = tool;
    const payload = {
      ...toolPayload,
      geometry: updatedGeometry,
        // Add scrolling flag if present on tool
       scrolling: tool.scrolling,
       value: {
      ...tool.value,
      reactivate_scroll: !!tool?.value?.reactivate_scroll,
      reactive: tool?.value?.reactivate_scroll ? "reactive" : ""
    },
    };
    // New lightbox content gets no page so it can never render at the page's top-left before it's linked.
    const isNewLightboxContent = skipPageElements && !editElement?.id && !elementId;
    if (isNewLightboxContent) payload.page = '';
    const formData = new FormData();
    const headers = {
      'X-CSRF-Token': document
        .querySelector('meta[name="csrf-token"]')
        .getAttribute('content'),
    };

    const sanitizedPayload = Object.entries(payload).reduce((acc, [key, value]) => {
      if (Array.isArray(value)) {
        if (value.length === 0) {
          return acc;
        }
        acc[key] = value;
        return acc;
      }
      acc[key] = value;
      return acc;
    }, {});

    for (const [key, value] of Object.entries(sanitizedPayload)) {
      if (!['element','tags','is_tenor'].includes(key) && (key !== 'docs_lightbox_id' || (isNewLightboxContent && value))) {
        if (Array.isArray(value)) {
          value.forEach((item) => formData.append(`${key}[]`, item));
          continue;
        }
        formData.append(
          key,
          key === 'file' || typeof value !== 'object'
            ? value
            : JSON.stringify(value)
        );
      }
    }


    if (editElement?.id && elementId) {
      formData.append('_method', 'patch');
    }

    let body, method, url;
    if (payload.file) {
      body   = formData;
      method = (!editElement?.id && !elementId) ? 'POST' : 'PATCH';
      url    = (!editElement?.id && !elementId)
        ? `/docs/elements`
        : `/docs/elements/${editElement.id ?? elementId}`;
    } else {
      headers['Content-Type'] = 'application/json';
      method = (!editElement?.id && !elementId) ? 'POST' : 'PATCH';
      url    = (!editElement?.id && !elementId)
        ? `/docs/elements.json`
        : `/docs/elements/${editElement.id ?? elementId}.json`;
      body = JSON.stringify(sanitizedPayload);
    }

    try {
      let response = await fetch(url, {
        method,
        headers,
        body,
        credentials: 'same-origin',
      });

      // Session expired: show login modal, hold the save, retry after re-auth.
      if (response.status === 401) {
        if (typeof window !== 'undefined' && window.__REQUIRES_AUTH__ && !window.__SESSION_TIMEOUT_ACTIVE__) {
          window.__SESSION_TIMEOUT_ACTIVE__ = true;
          window.dispatchEvent(new CustomEvent('app:session-expired'));
        }
        await new Promise((resolve) => {
          const handler = () => {
            window.removeEventListener('app:session-restored', handler);
            resolve();
          };
          window.addEventListener('app:session-restored', handler);
        });
        const freshToken = document.querySelector('meta[name="csrf-token"]')?.getAttribute('content');
        response = await fetch(url, {
          method,
          headers: { ...headers, 'X-CSRF-Token': freshToken || headers['X-CSRF-Token'] },
          body,
          credentials: 'same-origin',
        });
      }

      if (!response.ok) throw new Error(`Server returned ${response.status}`);

      const jsonResponse = await response.json();
      if (toolType !== 'LightboxesToolbox') {
        setShowToast({
          showToast:    true,
          toastType:    'success',
          toastMessage: editElement?.id ? 'Changes Saved' : 'Element Created',
        });
      }

      if (payload.element_type === '4' && payload.file && elementId && !skipPageElements) {
        const { file, ...updatedTool } = tool;
        handleSave(updatedTool);
      }

      if (!skipPageElements) {
        if (pushHistoryAction && toolType !== 'LightboxesToolbox') {
          if (editElement?.id) {
            const beforeSnapshot = editElement;
            const isImageFileEdit = payload.element_type === '4' && !!payload.file;
            const applyEdit = (snapshot) =>
              (isImageFileEdit
                ? patchElementFromImageSnapshot(jsonResponse.id, snapshot)
                : patchElement(jsonResponse.id, { ...snapshot, tags: 'keep' })
              ).then((response) => {
                setElements(prev => ({ ...prev, [response.data.id]: response.data }));
                return response;
              });
            pushHistoryAction({
              label: 'Edit element',
              undo: () => applyEdit(beforeSnapshot),
              redo: () => applyEdit(jsonResponse),
            });
          } else {
            const createdId = jsonResponse.id;
            pushHistoryAction({
              label: 'Add element',
              undo: () =>
                deleteElementById(createdId).then(() => {
                  setElements(prev => {
                    const { [createdId]: _removed, ...rest } = prev;
                    return rest;
                  });
                }),
              redo: () =>
                restoreElementById(createdId).then((response) => {
                  setElements(prev => ({ ...prev, [response.data.id]: response.data }));
                  return response;
                }),
            });
          }
        }
        setElements(prev => ({ ...prev, [jsonResponse.id]: jsonResponse }));
      }
      if (elementType === 'image' && toolType === 'LightboxesToolbox') {
        setImageElement(prev => ({ ...prev, [jsonResponse.id]: jsonResponse }));
      }
      if (!skipPageElements) {
        handleCloseModal(false);
      }
      return jsonResponse;
    } catch (error) {
      console.error('Upload failed:', error);
      setShowToast({
        showToast:    true,
        toastType:    'danger',
        toastMessage: 'Something Went Wrong',
      });
    }
  }

  handleSubmitBtnState();
};


    const removeDiv = () => {
        const divToRemove = document.getElementById("createdDivId");
        if (divToRemove) {
            divToRemove.remove();
        }
    };

    // handle element modal close
    const handleCloseModal = (status) => {
        setTool({})
        setEditElement({})
        setLiveTool(null)
        removeDiv()
        setToolType('')
        closeModal && closeModal(status)
        setEditEnabled(status)
        localStorage.removeItem('is_changed_model');
        if (window.tinymce) {
            window.tinymce.remove();
        }
        document.querySelectorAll('.tox-tinymce-aux').forEach(el => el.remove());
        handleSubmitBtnState();
    }

    // dynamically render element section with heading and component
    const ToolSection = () => {
        let result = {
            header: "",
            component: null,
        };
        switch (true) {
            case toolType === 'ImageToolbox' || editElement?.element_type === 4:
                result.header = toolType === 'Clone' ? 'Clone Element' : Object.values(editElement).length > 0 ? `Image settings ${editElement.id}` : "Add Image";
                result.component = (
                    <ImageSection
                        pickInPreview={toolType !== 'Clone' && toolType !== 'LightboxesToolbox'}
                        tool={tool}
                        handleImageUpload={handleImageUpload}
                        uploadElement={handleSubmitElement}
                        editElement={editElement}
                        handleSelectGifs={handleSelectGifs}
                        errorState={errorState}
                    />
                );
                break;
            case toolType === 'VideoToolbox' || editElement?.element_type === 5:
                result.header = toolType === 'Clone' ? 'Clone Element' : Object.values(editElement).length > 0 ? 'Video settings' : "Add Video";
                result.component = (
                    <VideoSection
                        handleVideoUrlUpload={handleElementUpload}
                        videoLink={tool?.value?.video_link}
                        errorState={errorState}
                    />
                );
                break;
            case toolType === 'TextToolbox' || editElement?.element_type === 7:
                result.header = toolType === 'Clone' ? 'Clone Element' : Object.values(editElement).length > 0 ? 'Text settings' : "Add Text";
                result.component = (
                    <TextEditorSection
                        handleTextChange={handleTextChange}
                        html_text={tool?.value?.html_text}
                        errorState={errorState}
                        totalPages={totalPages}
                        currentPage={tool?.page}
                    />
                );
                break;
            case toolType === 'EmbedToolbox' || editElement?.element_type === 6:
                result.header = toolType === 'Clone' ? 'Clone Element' : Object.values(editElement).length > 0 ? 'Embed settings' : "Add Embed";
                result.component = (
                    <EmbedSection
                        handleEmbedUrlUpload={handleElementUpload}
                        siteUrl={tool?.value?.video_link}
                        preventScroll={tool?.value?.no_scroll}
                        errorState={errorState}
                    />
                );
                break;
            case toolType === 'HotspotToolbox' || editElement?.element_type === 9:
                result.header = toolType === 'Clone' ? 'Clone Element' : Object.values(editElement).length > 0 ? 'Hotspot settings' : "Add Hotspot";
                result.component = (
                    <HotspotSection
                        tool={tool}
                        setTool={setTool}
                        handleHotspotUpload={handleElementUpload}
                        uploadElement={handleSubmitElement}
                    />
                );
                break;
            default:
                result.header = toolType === 'Clone' ? 'Clone Element' : Object.values(editElement).length > 0 ? `Image settings` : "Add Image";
                result.component = (
                    <ImageSection
                        tool={tool}
                        handleImageUpload={handleImageUpload}
                        uploadElement={handleSubmitElement}
                        editElement={editElement}
                        handleSelectGifs={handleSelectGifs}
                        errorState={errorState}
                    />
                );
        }
        return result;
    }

    // api call to send the lightbox id when images are added in the slider.
    const editImageInSlider = async (editId, data) => {
        const response = await networkService(`/docs/elements/${editId}.json`, 'PATCH', data)
        return response
    }

    //handle validations
    const handleValidations = (tool) => {
        const isVideoOrEmbed = toolType === "VideoToolbox" ||
            toolType === "EmbedToolbox" ||
            editElement?.element_type === 6 ||
            editElement?.element_type === 5;

        if (!tool?.value?.video_link && isVideoOrEmbed) {
            setErrorState({
                ...errorState,
                videoErr: 'Please add the embed code provided by youtube or vimeo. Link must contain http or https.',
                embedErr: 'Please add the URL. Link must contain http or https.'
            })
            return false
        }
        // Keep Save blocked while a prior "not an embed code" flag is still set.
        else if (isVideoOrEmbed && (errorState.videoErr || errorState.embedErr)) {
            return false
        }
        else if (!tool?.value?.html_text && (toolType === "TextToolbox" ||
            editElement?.element_type === 7)) {
            setErrorState({
                ...errorState,
                textErr: 'Please add the text'
            })
            return false
        } else if (
            (toolType === 'ImageToolbox' || editElement?.element_type === 4) &&
            (!tool?.file && !tool?.file_url && !tool?.value?.gif_link)
        ) {
            setErrorState({
                ...errorState,
                imgErr: 'Please select the Image Element'
            })
            return false
        } else if (!tool?.tags?.length && (
            actionKeys.some((key) => tool?.value?.hasOwnProperty(key)) ||
            Object.keys(tool?.dropdown_data || {}).length > 0
        ) && tool?.action != 'none') {
            setErrorState({
                ...errorState,
                tagErr: 'Please add a tag'
            })
            return false
        }
        else if (

            tool?.action === 'page' &&
            (
                Number(tool?.value?.page_link) === 0 ||
                Number(tool?.value?.page_link) > Number(totalPages) ||
                Number(tool?.value?.page_link) === Number(tool?.page)
            )
        ) {
            //todo
             if (Number(tool?.value?.page_link) === Number(tool?.page) ) {
                            setErrorState((prev) => ({
                                ...prev,
                                pageErr: "Please add a page number other than current page",
                            }));
                        }
            setErrorState({
                ...errorState,
                pageErr: Number(tool?.value?.page_link) === Number(tool?.page) ?
                    'Please add a page number other than current page' :
                    tool?.value?.page_link == 0 ?
                        'Please add a valid page number' :
                        'Please add a valid page number'
            })
            return false
        }
        else if (tool?.action === 'kdf' && !(tool?.value?.kdf && tool?.value?.link && tool?.value?.url)) {
            setErrorState({
                ...errorState,
                kdfErr: tool?.value?.kdf ? 'Please pick a LaserLINK from the list' : 'Please pick a KDF from the list'
            })
            return false
        }
        else if (tool?.action === 'href') {
            const { url, mail, phone } = tool?.value || {};
            if (!url && !mail && !phone) {
                setErrorState({ ...errorState, tagErr: '', hrefErr: 'Please add a URL, E-Mail or Phone for Link to' })
                return false
            }
            if (mail && !isValidEmail(mail)) {
                setErrorState({ ...errorState, tagErr: '', hrefErr: 'Please enter a valid email address' })
                return false
            }
            if (phone && !isValidPhone(phone)) {
                setErrorState({ ...errorState, tagErr: '', hrefErr: /^\+\d{0,4}$/.test(phone.trim()) ? 'Please enter the phone number after the country code' : 'Please enter a valid phone number, including its country code' })
                return false
            }
            if (url && !isValidHttpUrl(url)) {
                setErrorState({ ...errorState, tagErr: '', hrefErr: 'Please enter a valid URL' })
                return false
            }
            setErrorState({ ...errorState, tagErr: '', hrefErr: '' })
            return true
        }
        else if (tool?.action === 'link_and_jump') {
            const hasLjLink = !!(tool?.value?.lj_url || tool?.value?.lj_mail || tool?.value?.lj_phone);
            const hasLjPage = !!tool?.value?.lj_page_link;
            if (hasLjLink && !hasLjPage) {
                setErrorState({
                    ...errorState,
                    ljErr: 'Please add a page number for Jump to'
                })
                return false
            } else if (!hasLjLink && hasLjPage) {
                setErrorState({
                    ...errorState,
                    ljErr: 'Please add a URL, E-Mail or Phone for Link to'
                })
                return false
            } else if (!hasLjLink && !hasLjPage) {
                setErrorState({
                    ...errorState,
                    ljErr: 'Please fill in both Link to and Jump to fields'
                })
                return false
            } else if (
                Number(tool?.value?.lj_page_link) === 0 ||
                Number(tool?.value?.lj_page_link) > Number(totalPages) ||
                Number(tool?.value?.lj_page_link) === Number(tool?.page)
            ) {
                setErrorState({
                    ...errorState,
                    ljErr: Number(tool?.value?.lj_page_link) === Number(tool?.page) ?
                        'Please add a page number other than current page' :
                        'Please add a valid page number'
                })
                return false
            } else if (tool?.value?.lj_mail && !isValidEmail(tool.value.lj_mail)) {
                setErrorState({ ...errorState, tagErr: '', ljErr: 'Please enter a valid email address' })
                return false
            } else if (tool?.value?.lj_phone && !isValidPhone(tool.value.lj_phone)) {
                setErrorState({ ...errorState, tagErr: '', ljErr: /^\+\d{0,4}$/.test(tool.value.lj_phone.trim()) ? 'Please enter the phone number after the country code' : 'Please enter a valid phone number, including its country code' })
                return false
            } else if (tool?.value?.lj_url && !isValidHttpUrl(tool.value.lj_url)) {
                setErrorState({ ...errorState, tagErr: '', ljErr: 'Please enter a valid URL' })
                return false
            }
            return true
        }
        else {
            return true
        }
    }

    useEffect(() => {
        if (editElement.id) {
            const { docs_element_tags, action, geometry, ...rest } = editElement;
            const derivedAction = action ?? (
                rest.dropdown_data && Object.keys(rest.dropdown_data).length > 0 ? 'desiredaction' :
                rest.value?.page_link ? 'page' :
                rest.value?.light_box ? 'on' :
                rest.value?.kdf_title ? 'kdf' :
                (rest.value?.url || rest.value?.phone || rest.value?.mail) ? 'href' :
                (rest.value?.lj_page_link && (rest.value?.lj_url || rest.value?.lj_phone || rest.value?.lj_mail)) ? 'link_and_jump' :
                'none'
            );

            // For video/embed elements, try to extract dimensions from video_link if it's an iframe
            // and embed_dimensions don't exist
            let embedDimensions = rest.embed_dimensions || rest.value?.embed_dimensions;
            
            if (!embedDimensions && (rest.element_type === 5 || rest.element_type === 6 || rest.element_type === 8)) {
                const videoLink = rest.value?.video_link;
                if (videoLink && typeof videoLink === 'string' && videoLink.match(/^<iframe(.*?)><\/iframe>/gi)) {
                    const widthMatch = videoLink.match(/width=["']?(\d+)["']?/i);
                    const heightMatch = videoLink.match(/height=["']?(\d+)["']?/i);
                    
                    if (widthMatch && widthMatch[1] && heightMatch && heightMatch[1]) {
                        embedDimensions = {
                            width: parseInt(widthMatch[1], 10),
                            height: parseInt(heightMatch[1], 10)
                        };
                    }
                }
            }
            
            // Determine reactivate_scroll value from saved data
            const reactivateScrollValue = rest.value?.reactivate_scroll === true ||
                                          rest.value?.reactivate_scroll === 'true' ||
                                          rest.value?.reactive === 'reactive';

            const updatedElement = {
                ...rest,
                ...(rest.transparency !== undefined && rest.transparency !== null && rest.transparency !== '' && {
                    transparency: Number(rest.transparency)
                }),
                ...(rest.element_type !== undefined && rest.element_type !== null && {
                    element_type: String(rest.element_type)
                }),
                _baseGeometry: { ...geometry },
                geometry: {
                    ...geometry,
                    ...getNormalizedDimensions(geometry, zoom, pageDimensions)
                },
                action: derivedAction,
                tags: docs_element_tags || [],
                value: {
                    ...rest.value,
                    reactivate_scroll: reactivateScrollValue,
                    reactive: reactivateScrollValue ? 'reactive' : '',
                    ...(embedDimensions && { embed_dimensions: embedDimensions })
                },
                ...(embedDimensions && { embed_dimensions: embedDimensions })
            };
            setTool(updatedElement);
            setInitialTool(updatedElement);
            setInitialEditElement(editElement);
            setScrollActive(reactivateScrollValue);
            sessionStorage.setItem("scrolling", reactivateScrollValue);
        }
    }, [editElement])

    useEffect(() => {
        const divCreated = document.getElementById("createdDivId");
        if (!tool?.id && divCreated) {
            divCreated.style.zIndex = 999;
            divCreated.style.width = `${tool?.geometry?.width}px`;
            divCreated.style.height = `${tool?.geometry?.height}px`;
            divCreated.style.top = `${tool?.geometry?.top}px`;
            divCreated.style.left = `${tool?.geometry?.left}px`;
            divCreated.style.background = tool?.value?.bg_color || '';
            const previewImg = document.getElementById("createdDivIdPreview");
            if (previewImg) {
                previewImg.style.opacity = tool?.transparency ?? 1;
                previewImg.style.transform = `rotate(${Number(tool?.rotate) || 0}deg) scaleX(${tool?.flip === -1 ? -1 : 1})`;
                previewImg.parentElement.style.overflow = Number(tool?.rotate) ? 'visible' : 'hidden';
            }
            if (previewImg && !tool?.file) {
                const gifSrc = tool?.value?.gif_link || '';
                previewImg.src = gifSrc;
                previewImg.style.display = gifSrc ? 'block' : 'none';
            }
            const previewFrame = document.getElementById("createdDivIdPreviewFrame");
            if (previewFrame) {
                const videoSrc = embedConsent ? tool?.value?.video_link || '' : '';
                if (!videoSrc) previewFrame.removeAttribute('src');
                else if (previewFrame.getAttribute('src') !== videoSrc) previewFrame.src = videoSrc;
                previewFrame.style.display = videoSrc ? 'block' : 'none';
            }
            const previewText = document.getElementById("createdDivIdPreviewText");
            if (previewText) {
                const html = tool?.element_type === 7 ? tool?.value?.html_text || '' : '';
                previewText.innerHTML = sanitizeHtml(scaleFontSizesInHtml(html, parseFloat(zoom?.value ?? 1)));
                previewText.style.display = html ? 'block' : 'none';
                loadGoogleFontsInHtml(html);
            }
        }
    }, [tool, embedConsent])

    useEffect(() => {
        if (!tool?.file) return;
        const previewImg = document.getElementById("createdDivIdPreview");
        const url = URL.createObjectURL(tool.file);
        if (previewImg) {
            previewImg.src = url;
            previewImg.style.display = 'block';
        }
        return () => URL.revokeObjectURL(url);
    }, [tool?.file])

    useEffect(() => {
        setLiveTool(tool?.id && editElement?.id === tool?.id ? tool : null);
    }, [tool, editElement?.id])

    return {
        tool,
        ToolSection,
        handleCloseModal,
        handleSubmitElement,
        uploadElement,
        handleChange,
        toolType,
        editElement,
        handleElementUpload,
        setTool,
        editImageInSlider,
        handleTextChange, handleHtmlChange, scrollActive,
        initialTool, setInitialTool,
        initialEditElement, setInitialEditElement,
        isChanged, setIsChanged,
        errorState,
        handleSubmitBtnState,
        showExtendModal,setShowExtendModal,confirmedGeometry,
        handleImageUpload,
        handleSelectGifs,
    };
};

export default useEditorHook;
